import { render, staticRenderFns } from "./cashier.vue?vue&type=template&id=2cfc33e6&"
import script from "./cashier.vue?vue&type=script&lang=js&"
export * from "./cashier.vue?vue&type=script&lang=js&"
import style0 from "./cashier.vue?vue&type=style&index=0&id=2cfc33e6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports